import React, { useReducer, useContext, createContext } from 'react';
import reducer from './reducer';
import * as types from './constants';


const initialState = {
  user: {
    username: "",
    userId: "",
    result: null,
  },
  setUserId: () => {},
  setResult: () => {}
};


const GlobalContext = createContext(initialState);


const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const handleSetUserId = (userId) => {
    dispatch({
      type: types.SET_USER_ID,
      payload: userId,
    });
  };

  const handleSetResult = (result) => {
    dispatch({
      type: types.SET_RESULT,
      payload: result,
    });
  };

  const handleSetUserName = (name) => {
    dispatch({
      type: types.SET_NAME,
      payload: name,
    });
  };


  return (
    <GlobalContext.Provider
      value={{
        ...state,
        setUserId: handleSetUserId,
        setResult: handleSetResult,
        setUserName: handleSetUserName,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

const useGlobalContext = () => useContext(GlobalContext);

export { GlobalContext, GlobalProvider, useGlobalContext };
